import React, { useEffect, useState } from "react";
import classnames from "classnames";

const defaultButton = (props) => (
    <button
        type="button"
        {...props}
        className="-btn"
    >
        {props.children}
    </button>
);

const ReactTablePagination = (props) => {
    const PreviousComponent = props.PreviousComponent || defaultButton;
    const NextComponent = props.NextComponent || defaultButton;
    const [page, setPage] = useState(props.page);
    const [showing, setShowing] = useState({
        start: 0,
        end: 0,
        total: 0,
    });

    useEffect(() => {
        setPage(props.page);
        setShowing(getShowingData());
    }, [props.sortedData, props.page, props.pageSize]);

    const getShowingData = () => {
        const totalRecords = props.totalRecords || props.sortedData.length;

        return {
            start: totalRecords > 1 ? props.page * props.pageSize + 1 : 0,
            end: Math.min((props.page + 1) * props.pageSize, totalRecords),
            total: totalRecords,
        };
    };

    const getSafePage = (oldPage) => {
        if (isNaN(oldPage)) {
            oldPage = props.page;
        }

        return Math.min(Math.max(oldPage, 0), props.pages - 1);
    };

    const changePage = (p) => {
        const newPage = getSafePage(p);
        setPage(newPage);

        if (props.page !== newPage) {
            props.onPageChange(newPage);
        }
    };

    const applyPage = (e) => {
        if (e) {
            e.preventDefault();
        }

        changePage(page);
    };

    return (
        <div
            className={classnames(props.className, "-pagination")}
            style={props.style}
        >
            <div className="-previous">
                <PreviousComponent
                    onClick={() => {
                        if (!props.canPrevious) return;

                        changePage(props.page - 1);
                    }}
                    disabled={!props.canPrevious || props.pagingDisabled}
                >
                    {props.previousText}
                </PreviousComponent>
            </div>
            <div className="-center">
                <span className="-pageInfo">
                    {props.pageText}{" "}
                    {props.showPageJump ? (
                        <div className="-pageJump">
                            <input
                                disabled={props.pagingDisabled}
                                type={page === "" ? "text" : "number"}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    const newPage = val - 1;

                                    if (val === "") {
                                        return setPage("");
                                    }

                                    setPage(getSafePage(newPage));
                                }}
                                value={page === "" ? "" : page + 1}
                                onBlur={applyPage}
                                onKeyPress={(e) => {
                                    if (e.which === 13 || e.keyCode === 13) {
                                        applyPage();
                                    }
                                }}
                            />
                        </div>
                    ) : (
                        <span className="-currentPage">{page + 1}</span>
                    )}{" "}
                    {props.ofText} <span className="-totalPages">{props.pages > 0 ? props.pages : 1}</span>
                </span>

                {typeof showing.total !== "undefined" ? (
                    <span className="-rowInfo">
                        {"Showing "}
                        <span className="-rowMin">{showing.start}</span>
                        {" - "}
                        <span className="-rowMax">{showing.end}</span>
                        {" of "}
                        <span className="-rowCount">{showing.total}</span>
                        {" total rows"}
                    </span>
                ) : (
                    ""
                )}

                {props.showPageSizeOptions && (
                    <span className="select-wrap -pageSizeOptions">
                        <select
                            disabled={props.pagingDisabled}
                            onChange={(e) => props.onPageSizeChange(Number(e.target.value))}
                            value={props.pageSize}
                        >
                            {props.pageSizeOptions.map((option, i) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <option
                                    key={i}
                                    value={option}
                                >
                                    {option} {props.rowsText}
                                </option>
                            ))}
                        </select>
                    </span>
                )}
            </div>
            <div className="-next">
                <NextComponent
                    onClick={() => {
                        if (!props.canNext) return;

                        changePage(props.page + 1);
                    }}
                    disabled={!props.canNext || props.pagingDisabled}
                >
                    {props.nextText}
                </NextComponent>
            </div>
        </div>
    );
};

ReactTablePagination.defaultProps = {
    sortedData: [],
};

export default ReactTablePagination;
